// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EnterEmail_loginFormContainer__XYBYY {
  width: 448px;
  height: 455px;
  background-color: var(--color-bg-login-box);
  margin-left: auto;
  margin-right: auto;
  margin-top: 80px;
  box-shadow: 0px 3px 6px var(--color-theme-cloud);
  display: flex;
  flex-direction: column;
}

.EnterEmail_loginFormHeader__Wr0R4 {
  color: var(--color-font-2);
  font-weight: bold;
  font-size: 22px;
  margin-bottom: 40px;
}

.EnterEmail_loginForm__LW85v {
  margin: 40px;
}

.EnterEmail_input_container__z\\+34a {
  width: 100% !important;
  margin: 10px 0px;
}

.EnterEmail_two_buttons_container__lgsmz {
  margin-top: 60px;
  display: flex;
  justify-content: space-between;
}

.EnterEmail_button__cu9Yu {
  width: 174px;
  height: 41px;
  border: 1px solid var(--color-theme-blue) !important;
  border-radius: 4px;
  background-color: var(--color-theme-white) !important;
  color: var(--color-theme-blue) !important;
  cursor: pointer;
  font-size: 16px;
}

.EnterEmail_button__cu9Yu:hover {
  color: var(--color-theme-white) !important;
  background-color: var(--color-theme-blue) !important;
}

.EnterEmail_button_cancel__o1R0S {
  width: 174px;
  height: 41px;
  border: 1px solid var(--color-theme-deactivated) !important;
  border-radius: 4px;
  background-color: var(--color-theme-white) !important;
  color: var(--color-theme-deactivated) !important;
  cursor: pointer;
  font-size: 16px;
}

.EnterEmail_button_cancel__o1R0S:hover {
  color: var(--color-theme-white) !important;
  background-color: var(--color-theme-deactivated) !important;
}
`, "",{"version":3,"sources":["webpack://./src/@_components/ForgotPassword/EnterEmail/EnterEmail.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,2CAA2C;EAC3C,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,gDAAgD;EAChD,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,qDAAqD;EACrD,yCAAyC;EACzC,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,oDAAoD;AACtD;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,2DAA2D;EAC3D,kBAAkB;EAClB,qDAAqD;EACrD,gDAAgD;EAChD,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,2DAA2D;AAC7D","sourcesContent":[".loginFormContainer {\n  width: 448px;\n  height: 455px;\n  background-color: var(--color-bg-login-box);\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 80px;\n  box-shadow: 0px 3px 6px var(--color-theme-cloud);\n  display: flex;\n  flex-direction: column;\n}\n\n.loginFormHeader {\n  color: var(--color-font-2);\n  font-weight: bold;\n  font-size: 22px;\n  margin-bottom: 40px;\n}\n\n.loginForm {\n  margin: 40px;\n}\n\n.input_container {\n  width: 100% !important;\n  margin: 10px 0px;\n}\n\n.two_buttons_container {\n  margin-top: 60px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.button {\n  width: 174px;\n  height: 41px;\n  border: 1px solid var(--color-theme-blue) !important;\n  border-radius: 4px;\n  background-color: var(--color-theme-white) !important;\n  color: var(--color-theme-blue) !important;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.button:hover {\n  color: var(--color-theme-white) !important;\n  background-color: var(--color-theme-blue) !important;\n}\n\n.button_cancel {\n  width: 174px;\n  height: 41px;\n  border: 1px solid var(--color-theme-deactivated) !important;\n  border-radius: 4px;\n  background-color: var(--color-theme-white) !important;\n  color: var(--color-theme-deactivated) !important;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.button_cancel:hover {\n  color: var(--color-theme-white) !important;\n  background-color: var(--color-theme-deactivated) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginFormContainer": `EnterEmail_loginFormContainer__XYBYY`,
	"loginFormHeader": `EnterEmail_loginFormHeader__Wr0R4`,
	"loginForm": `EnterEmail_loginForm__LW85v`,
	"input_container": `EnterEmail_input_container__z+34a`,
	"two_buttons_container": `EnterEmail_two_buttons_container__lgsmz`,
	"button": `EnterEmail_button__cu9Yu`,
	"button_cancel": `EnterEmail_button_cancel__o1R0S`
};
export default ___CSS_LOADER_EXPORT___;
